import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"
import { TouristProfilesList } from "../../../../../TouristProfiles"

export default function OrganizationTouristsProfilePage() {
	return (
		<>
			<Helmet>
				<title>Tourist Profiles</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<TouristProfilesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
